module.exports = __webpack_public_path__ + "static/media/long-context.ec562e19.svg";